import { render, staticRenderFns } from "./Hint_comp.vue?vue&type=template&id=9dded658&scoped=true&"
import script from "./Hint_comp.vue?vue&type=script&lang=js&"
export * from "./Hint_comp.vue?vue&type=script&lang=js&"
import style0 from "./Hint_comp.vue?vue&type=style&index=0&id=9dded658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dded658",
  null
  
)

export default component.exports